import { Button, Modal, Col } from "react-bootstrap";
import team2 from "../../assets/images/team/team-2-modal.jpg";
import useLang from "hooks/useLang";

const ModalTirta = (props) => {
  const { lang } = useLang();

  return (
    <Modal
      id="modal-detail"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <div id="modal-detail-img">
          <Col lg={6} sm={6} className="center">
            <div className="member box-tab">
              <div className="pic owner effect">
                <img src={team2} alt=""/>
              </div>
              <h4>Tirta</h4>
              <span>Managing Partner & CFO</span>
            </div>
          </Col>
        </div>
        <ul className="inline-item">
          <li className="list-inline-item">
            <i className="uil uil-bell"></i>
            <div>
              <p className="text-muted">
                Registered Tax Consultant from the Ministry of Finance of the
                Republic of Indonesia.
              </p>
            </div>
          </li>
          <li className="list-inline-item">
            <i className="uil uil-star"></i>
            <div>
              <p className="text-muted">Licensed Tax Attorney for Tax Court.</p>
            </div>
          </li>
          <li className="list-inline-item">
            <i className="uil uil-envelope-minus"></i>
            <div>
              <p className="text-muted">
                Accounting, University of Pelita Harapan.
              </p>
            </div>
          </li>
          <li className="list-inline-item">
            <i className="uil uil-heart-alt"></i>
            <div>
              <p className="text-muted">
                Member of International Fiscal Association (IFA).
              </p>
            </div>
          </li>
          <li className="list-inline-item">
            <i className="uil uil-heart-alt"></i>
            <div>
              <p className="text-muted">
                Member of Indonesian Tax Consultant Association (IKPI) and Indonesia Chartered Accountants (IAI).
              </p>
            </div>
          </li>
        </ul>
        <p style={{ textAlign: "justify" }}>{lang.our_team.card_3_detail}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalTirta;